// @generated by protobuf-ts 2.9.4
// @generated from protobuf file "mlmbox/client/app/app.proto" (package "mlmbox.client.app", syntax proto3)
// tslint:disable
import { Scheme } from "../../types/scheme.ts";
import { Empty } from "../../../google/protobuf/empty.ts";
import { ServiceType } from "@protobuf-ts/runtime-rpc";
/**
 * @generated ServiceType for protobuf service mlmbox.client.app.App
 */
export const App = new ServiceType("mlmbox.client.app.App", [
    { name: "SchemeInfo", options: {}, I: Empty, O: Scheme }
]);
